import React from 'react';

import { Icon } from '../Icon';

import { BannerWrapper, CloseButton } from './InfoBanner.styles';

type InfoBannerProps = {
  onClose: () => void;
  children: React.ReactNode;
};

export const InfoBanner: React.FC<InfoBannerProps> = ({ onClose, children }) => {
  return (
    <BannerWrapper>
      <CloseButton onClick={onClose}>
        <Icon size={24} i="Close" />
      </CloseButton>
      {children}
    </BannerWrapper>
  );
};
